export default __webpack_public_path__ + "static/media/mrw-mssii.47148453.svg";